module.exports = __webpack_public_path__ + "media/images/logo-blog-28d7885d3c8bde00f3d1430b6b77dcbd.svg";